
import service from '@/utils/request'

/**
 * @description: 获取锐明平台用户管理第三方页面URL
 * @return {string} 第三方页面URL
 */
export const getExtUserManagePageAPI = (): Promise<any> => {
  return service.request({
    url: '/alpha/extPageUsermanage',
    method: 'post',
    data: {}
  })
}
